import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const GetShippingCompanyForFastCargo = () => request({
    url: ApiURL.Query.GetShippingCompanyForFastCargo,
    method: RequestType.GET,
});

const GetFastDeliveryCargo = (data: any) => request({
    url: ApiURL.Query.GetFastDeliveryCargo,   
    method: RequestType.POST,
    data: data
});

const FastDeliveryCargoManagementServiceQuery = {
    GetShippingCompanyForFastCargo,
    GetFastDeliveryCargo,
};

export default FastDeliveryCargoManagementServiceQuery; 